




import React, { useEffect, useState } from "react";
import { Modal, Input, Select, Button, Form, notification } from "antd";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../Common/APIConstants";
import { useNavigate, useLocation } from "react-router-dom";
import PopupUI from "../Elements/PopupUI";
import { CONFIGURATION_STEAM_SUB_GROUP, CONFIGURATION_SUB_GROUP, CONFIGURATION_SUBGROUPS, CONFIGURATION_WATER_SUB_GROUP } from "../../Common/Constants";
import { useSelector } from "react-redux";

const SubGroupPopupContent = ({
  onClose,
  isAdd,
  isUpdate,
  setIsUpdate,
  flowGroupList,
  updateRecordSub,
  setFlowSubGroupList,
  flowSubGroupList,
  selectedGroupNameID,
  fetchFlowGroupList,
  fetchUpdatedFlowSubGroupList,
  form

}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();

  const [addFormData, setAddFormData] = useState({});
  const [reportStatusList, setReportStatusList] = useState([]);
  const [calculationTypeList, setCalculationTypeList] = useState([]);

  const [updateformData, setUpdateFormData] = useState({
    SubGroupID: "",
    SubGroupName: "",
    CalculationTypeID: "",
    GroupID: "",
    ReportStatus: "",
  });

// console.log(flowSubGroupList)



  const fetchData =  () => {
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_CALCULATION_TYPE_MASTER_DETAILS,
    }).then((res) => {
      setCalculationTypeList(res);
      // console.log(res);
    });

    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_REPORT_STATUS_MASTER_DETAILS,
    }).then((res) => {
      setReportStatusList(res);
      // console.log(res);
    });

   
  };

  useEffect(() => {
    fetchData();
  
   
  }, []);



useEffect(() => {
    if (isUpdate && updateRecordSub) {
      console.log(updateRecordSub)
      const initialData = {
        SubGroupID: updateRecordSub?.subGroupID ? Number(updateRecordSub.subGroupID) : "",
        SubGroupName: updateRecordSub?.subGroupName || "",
        CalculationTypeID: updateRecordSub?.calculationTypeID === 'Plus' ? 1 : 2,
        GroupID: updateRecordSub?.groupID ? Number(updateRecordSub.groupID) : "",
        ReportStatus: updateRecordSub?.reportStatus === "Allow" ? 1 : 2,
      };
      
      // Set initial values to the form
      form.setFieldsValue(initialData);
      

      setUpdateFormData(initialData);
      form.setFieldsValue(initialData);
    }
  }, [isUpdate, updateRecordSub, form]);


  const handleClear = () => {
    form.resetFields();
  };

  const handleNotification = (msg) => {
    notification.open({
      message: `${msg}`,
    });
  };


  useEffect(() => {
    if (isAdd) {
      form.resetFields();
    }
  }, [isAdd, form]);


  const handleAddFormChange = (changedValues, allValues) => {
    setAddFormData(allValues);
  };

 
 
  const handleAddFormSubmit = async () => {
    try {
      const formData = {
        SubGroupName: addFormData.SubGroupName1,
        CalculationTypeID: Number(addFormData.CalculationTypeID1),
        GroupID: Number(addFormData.GroupID1),
        ReportStatus: Number(addFormData.ReportStatus1),
      };
  
      // Fetch the data for the selected GroupID
      const fetchDataForSubGroup = await makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.GET_FLOW_SUB_GROUPS_DETAILS}?GroupID=${formData.GroupID}`,
      });
 
      // Check if the fetched data contains any item with the same subGroupName
      const isDuplicate = fetchDataForSubGroup.some(
        (item) => item.subGroupName === formData.SubGroupName && item.groupID === formData.GroupID
      );
      
  
      if (isDuplicate) {
        notification.warning({
          message: "warning",
          description: "Group  with the same Subgroup already exists.",
        });
        return;
      }
  
      // If not duplicate, proceed with adding the subgroup
      await makeRequest({
        type: APIConstants.POST,
        url: APIConstants.INSERT_FLOW_SUB_GROUP_METER_DETAILS,
        body: formData,
      }).then(() => {
        handleNotification("Successfully Saved");
        // Refetch data for the selected group after adding the subgroup
        fetchUpdatedFlowSubGroupList();
      });
  
      handleClear();
      onClose();
    } catch (err) {
      console.log(err);
    }
  };
  


  
  
  
  const handleUpdateFormChange = (changedValues, allValues) => {
    // console.log("Updated SubGroupName:", allValues);

    setUpdateFormData((prev) => ({
          ...prev,
          ...allValues,
         
        }));
        
  };
  

  const handleUpdateFormSubmit = async() => {
    try {
      const formData = {
        subGroupID: updateformData?.SubGroupID,
        subGroupName: updateformData?.SubGroupName,
        calculationTypeID:Number(updateformData?.CalculationTypeID),
        groupID: updateformData?.GroupID,
        reportStatus:Number(updateformData?.ReportStatus),
      };
      
     

      const isDuplicateUpdate = flowSubGroupList.some(
        (item) =>
          item.groupID === formData.groupID &&
          item.subGroupName === formData.subGroupName 
          
      );
  
      if (isDuplicateUpdate) {
        notification.error({
          message: "Error",
          description: "Group with the same name and  module already exists.",
        });
        return; 
      }



      // console.log(formData);
  
      await makeRequest({
        type: APIConstants.PUT,
        url: APIConstants.UPDATE_FLOW_SUB_GROUP_METER_DETAILS,
        body: formData,
      }).then(() => {
        handleNotification("Successfully Updated");
  
       
  // fetchFlowGroupList()

  fetchUpdatedFlowSubGroupList();
  handleClear();
        onClose();
      });
    } catch (err) {
      console.log(err);
    }
  };
  const modeselect = useSelector((state) => state.darkMode);

  const { isdarkMode } = modeselect;

  return (
    <>
      {isAdd ? (
        <Form
          form={form}
          onFinish={handleAddFormSubmit}
          name="subgroup-add-form"
          className="font-bold w-[350px]"
          labelCol={{ span: 10 }}
          layout="horizontal"
          onValuesChange={handleAddFormChange}
        >
          <Form.Item
            label="Group Name"
            name="GroupID1"
            rules={[{ required: true, message: "Please select group name" }]}
          >
            <Select 
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {flowGroupList?.map((item) => (
                <Select.Option key={item.groupID} value={item.groupID}>
                  {item.groupName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="SubGroup Name"
            name="SubGroupName1"
            rules={[{ required: true, message: "Please enter sub group name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="SubGroup Type"
            name="CalculationTypeID1"
            rules={[
              { required: true, message: "Please select sub group type" },
            ]}
          >
            <Select 
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {calculationTypeList?.map((item) => (
                <Select.Option
                  key={Number(item.calculationTypeID)}
                  value={Number(item.calculationTypeID)}
                >
                  {item.calculationTypeName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Report Status"
            name="ReportStatus1"
            rules={[{ required: true, message: "Please select report status" }]}
          >
            <Select
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {reportStatusList?.map((item) => (
                <Select.Option
                  key={item?.reportStatusID}
                  value={item?.reportStatusID}
                >
                  {item?.reportStatusName === "Yes" ? "Allow" : "Not Allow"}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item className="flex justify-end ">
            <Button htmlType="submit" className="blue-btn mr-2">
              Save
            </Button>
            <Button className="blue-btn" onClick={handleClear}>
              Clear
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <Form
          form={form}
          onFinish={handleUpdateFormSubmit}
          name="subgroup-update-form"
          className="font-bold w-[350px]"
          labelCol={{ span: 10 }}
          layout="horizontal"
          onValuesChange={handleUpdateFormChange}
          initialValues={updateformData}
         
        >
          <Form.Item
            label="Group Name"
            name="GroupID"
            rules={[{ required: true, message: "Please select group name" }]}
          >
            <Select className={isdarkMode ? 'select-dropdown-background  ' : 'light-mode-dropdown'} disabled>
              {flowGroupList?.map((item) => (
                <Select.Option key={item.groupID} value={item.groupID}>
                  {item.groupName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="SubGroup Name"
            name="SubGroupName"
            rules={[{ required: true, message: "Please enter sub group name" }]}
          >
            <Input value={updateformData.SubGroupName} />
          </Form.Item>
          <Form.Item
            label="SubGroup Type"
            name="CalculationTypeID"
            rules={[
              { required: true, message: "Please select sub group type" },
            ]}
          >
            <Select 
            
            className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {calculationTypeList?.map((item) => (
                <Select.Option
                  key={Number(item.calculationTypeID)}
                  value={Number(item.calculationTypeID)}
                >
                  {item.calculationTypeName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Report Status"
            name="ReportStatus"
            rules={[{ required: true, message: "Please select report status" }]}
          >
            <Select 
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {reportStatusList?.map((item) => (
                <Select.Option
                  key={item?.reportStatusID}
                  value={item?.reportStatusID}
                >
                  {item?.reportStatusName === "Yes" ? "Allow" : "Not Allow"}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item className="flex justify-end ">
            <Button htmlType="submit" className="blue-btn mr-2">
              Save
            </Button>
            <Button className="blue-btn" onClick={handleClear}>
              Clear
            </Button>
          </Form.Item>
        </Form>
      )}
    </>
  );
};



 

const SubGroupPopup = ({ 
  isAdd,
  setIsAdd,
  isUpdate,
  setIsUpdate,
  flowGroupList,
  updateRecordSub,
  setFlowSubGroupList,
  flowSubGroupList,
  selectedGroupNameID,
  fetchFlowGroupList,
  fetchUpdatedFlowSubGroupList,
  title,

}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm()

  const handlePopupState = (path) => {
    if (path.includes(`${CONFIGURATION_SUB_GROUP}/group-add-popup`)) {
      setIsAdd(true);
      setIsUpdate(false);
      form.resetFields();
    } else if(path.includes(`${CONFIGURATION_STEAM_SUB_GROUP}/group-add-popup`)) {
      setIsAdd(true);
      setIsUpdate(false);
      form.resetFields();
    }  else if(path.includes(`${CONFIGURATION_WATER_SUB_GROUP}/group-add-popup`)) {
      setIsAdd(true);
      setIsUpdate(false);
      form.resetFields();
    } else if (path.includes(`${CONFIGURATION_SUB_GROUP}/group-update-popup`)) {
      setIsUpdate(true);
      setIsAdd(false);
    } else if(path.includes(`${CONFIGURATION_STEAM_SUB_GROUP}/group-update-popup`)){
      setIsAdd(false);
      setIsUpdate(false);
    } else if(path.includes(`${CONFIGURATION_WATER_SUB_GROUP}/group-update-popup`)){
      setIsAdd(false);
      setIsUpdate(false);
    } 
  };


  useEffect(() => {
    handlePopupState(location.pathname);
    console.log(location.pathname)
  }, [location.pathname, form]);



  const handleClose = () => {
    setIsAdd(false);
    setIsUpdate(false);

    // Get the current path
    const currentPath = location.pathname;

    // Determine the base path based on the current path
    if (currentPath.includes(`${CONFIGURATION_SUB_GROUP}/sub-group-add-popup`)) {
      navigate(CONFIGURATION_SUB_GROUP);
    } else if (currentPath.includes(`${CONFIGURATION_STEAM_SUB_GROUP}/sub-group-add-popup`)) {
      navigate(CONFIGURATION_STEAM_SUB_GROUP);
    } else if (currentPath.includes(`${CONFIGURATION_WATER_SUB_GROUP}/sub-group-add-popup`)) {
      navigate(CONFIGURATION_WATER_SUB_GROUP);
    }

    // Reset the form fields
    form.resetFields();
  };
  // console.log(updateRecordSub)

  return (
    <PopupUI
      popupContent={
        <SubGroupPopupContent
          onClose={handleClose}
          isAdd={isAdd}
          isUpdate={isUpdate}
          flowGroupList={flowGroupList}
          updateRecordSub={updateRecordSub}
          setFlowSubGroupList={setFlowSubGroupList}
          flowSubGroupList={flowSubGroupList}
          selectedGroupNameID={selectedGroupNameID}
          fetchFlowGroupList={fetchFlowGroupList}
          fetchUpdatedFlowSubGroupList={fetchUpdatedFlowSubGroupList} 
          form={form}
          title={title}

        />
      }
      key={updateRecordSub?.subGroupID}
      isAdd={isAdd}
      setIsAdd={setIsAdd}
      isUpdate={isUpdate}
      setIsUpdate={setIsUpdate}
      flowGroupList={flowGroupList}
      updateRecordSub={updateRecordSub}
      handleClose={handleClose}
      fetchUpdatedFlowSubGroupList={fetchUpdatedFlowSubGroupList} 
      title={title}

    />
  );
};

export default SubGroupPopup;

